import { CLIENT_GLOBAL_KEY, PROCESS_KEY } from '../constants'

export const SHARED_TRANSLATIONS_KEY = '__shared_translations__' as const
/**
 *
 * Retrieves the client translations script for a given locale and hash from globalThis["i18n"].translationsInlineCodeByRouteHash if it exists
 * Otherwise, builds it and populates globalThis["i18n"].translationsInlineCodeByRouteHash
 * @example "window.__BackmarketTranslations = {"translations":{"home-title":"Home","click-cta":"Click",...}};
 */
export function getTranslationsScript({
  locale,
  hash,
  translationKeysByHash,
  hashByRoute,
}: {
  locale: string
  hash: string
  translationKeysByHash: Record<string, string[]>
  hashByRoute: Record<string, string>
}) {
  const { translationsInlineCodeByRouteHash } = globalThis[PROCESS_KEY]
  const hasRoute = hash in (translationsInlineCodeByRouteHash || {})

  if (!hasRoute) {
    translationsInlineCodeByRouteHash[hash] = {}
  }

  const hasLocale = locale in (translationsInlineCodeByRouteHash[hash] || {})
  if (hasLocale) {
    return translationsInlineCodeByRouteHash[hash][locale]
  }

  const routeTranslationsKeys = translationKeysByHash[hash] || []

  const sharedTranslationsHash =
    hashByRoute[SHARED_TRANSLATIONS_KEY as keyof typeof hashByRoute]

  const sharedTranslationsKeys =
    translationKeysByHash[sharedTranslationsHash] || []

  const routeTranslations: Record<string, string> = {}
  for (const key of [...routeTranslationsKeys, ...sharedTranslationsKeys]) {
    routeTranslations[key] =
      globalThis[PROCESS_KEY].translationsByLocale[locale]?.[key] || ''
  }

  const translationsScript = `window.${CLIENT_GLOBAL_KEY} = ${JSON.stringify({ translations: routeTranslations })};`

  translationsInlineCodeByRouteHash[hash][locale] = translationsScript

  return translationsScript
}
